export { default } from './SubFrequencyTag';
